import { useDispatch } from "react-redux";

export * from "./dataActions";
export * from "./fetchActions";
export * from "./authActions";
export * from "./resourcesActions";
export * from "./listActions";
export * from "./uiActions";
export * from "./localeActions";
export * from "./notificationActions";
export * from "./analyticsActions";

/** @deprecated We are phasing out legacy redux, use immi query instead */
export const useAsyncDispatch = () => {
  const dispatch = useDispatch();
  return (action) =>
    new Promise((resolve, reject) => {
      dispatch({ ...action, resolve, reject });
    });
};
